export default "__VITE_ASSET__79e034b9__"